module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h3', [_vm._v("Engaged Audience Profiles")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "heading"
    },
    slot: "heading"
  }, [_vm._v("Statistics calculated from profiles that exist")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "Loading Audience Profiles..."
    }
  }, [(_vm.hasData) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('pie-chart', {
    attrs: {
      "height": 250,
      "data": _vm.data.age,
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "chart-box",
    attrs: {
      "span": 7
    }
  }, [_c('table-chart', {
    attrs: {
      "label": "Language",
      "data": _vm.data.language
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "chart-box",
    attrs: {
      "span": 8
    }
  }, [_c('table-chart', {
    attrs: {
      "label": "Location",
      "data": _vm.data.location
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('pie-chart', {
    attrs: {
      "height": 250,
      "data": _vm.data.gender,
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "chart-box",
    attrs: {
      "span": 8
    }
  }, [_c('table-chart', {
    attrs: {
      "label": "Channels",
      "data": _vm.data.numberOfChannels
    }
  })], 1)], 1)], 1) : _c('div', {
    staticStyle: {
      "height": "525px"
    }
  }, [_c('small', {
    staticClass: "graph-empty"
  }, [_vm._v("No Data Loaded")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c466a20","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/charts/AudienceProfileChart.vue
// module id = 3163
// module chunks = 3